<!-- Use the shared modal component with xl size for split layout -->
<app-modal [isOpen]="visible" (isOpenChange)="visibleChange.emit($event)" size="xl" [noContentPadding]="true">
  <!-- Turnstile container (hidden) -->
  <div id="cf-turnstile" style="height: 0; overflow: hidden"></div>

  <!-- Split layout container -->
  <div class="flex flex-col md:flex-row min-h-[500px]">
    <!-- Left panel: Feature carousel (hidden on mobile) -->
    <div class="hidden md:flex md:w-[60%] relative bg-gradient-to-br from-gray-900 via-gray-900 to-black overflow-hidden rounded-l-xl md:min-w-0">
      <app-login-carousel [isOpen]="visible"></app-login-carousel>
    </div>

    <!-- Right panel: Login form (narrow column; image takes more width) -->
    <div class="flex-1 md:flex-none md:w-[40%] flex flex-col justify-center px-6 py-10 sm:px-8 md:px-8 bg-gray-100 dark:bg-black md:min-w-0">
      <div class="w-full max-w-[300px] mx-auto">
      <!-- Login/Register Header -->
      <div class="mb-8" *ngIf="!codeSent">
        <h2 class="text-xl font-bold text-gray-900 dark:text-white">
          {{ isSignUpMode ? 'Create an account' : 'Welcome to Design Jobs' }}
        </h2>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          {{
            isSignUpMode
              ? 'Sign up to start applying for jobs'
              : 'Sign in to continue'
          }}
        </p>
      </div>

      <!-- Error Message Display -->
      <div
        *ngIf="errorMessage"
        class="mb-4 p-3 rounded-md border-1 border-red-600 dark:border-red-700 bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400"
      >
        {{ errorMessage }}
      </div>

      <!-- Form Error Display -->
      <div
        *ngIf="formError"
        class="mb-4 p-3 rounded-md border-1 border-red-600 dark:border-red-700 bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400"
      >
        {{ formError }}
      </div>

      <!-- Success Message Display -->
      <div
        *ngIf="successMessage"
        class="mb-4 p-3 rounded-xl bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400"
      >
        {{ successMessage }}
      </div>

      <!-- Email Step -->
      <div *ngIf="!showVerificationForm">
        <!-- Google Sign-In Button -->
        <button
      type="button"
      (click)="signInWithGoogle()"
      [disabled]="isSubmittingGoogle"
      class="btn-secondary w-full disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-0"
    >
      <span
        *ngIf="!isSubmittingGoogle"
        class="flex items-center justify-center"
      >
        <svg
          class="w-5 h-5 mr-3"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          width="48px"
          height="48px"
        >
          <path
            fill="#FFC107"
            d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
          />
          <path
            fill="#FF3D00"
            d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
          />
          <path
            fill="#4CAF50"
            d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
          />
          <path
            fill="#1976D2"
            d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l6.19,5.238C39.712,34.407,44,28.779,44,24C44,22.659,43.862,21.35,43.611,20.083z"
          />
        </svg>
        {{
          isSignUpMode ? 'Sign up with Google' : 'Continue with Google'
        }}
      </span>
      <span *ngIf="isSubmittingGoogle" class="flex items-center justify-center">
        <svg
          class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700 dark:text-gray-300 inline"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        Redirecting...
      </span>
    </button>

    <!-- Divider -->
    <div class="relative my-5">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-gray-300 dark:border-gray-700"></div>
      </div>
      <div class="relative flex justify-center text-sm">
        <span
          class="px-3 text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-black"
        >
          or
        </span>
      </div>
    </div>

    <!-- Email Form -->
    <form [formGroup]="emailForm" (ngSubmit)="signInWithEmail()">
      <div class="mb-5">
        <label
          for="email"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
        >
          Email
        </label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black/15 dark:focus:ring-white/25 focus:border-transparent transition-all duration-200"
          placeholder="you@example.com"
          [class.is-invalid]="
            emailForm.get('email')?.invalid && emailForm.get('email')?.touched
          "
        />
        <div
          *ngIf="
            emailForm.get('email')?.invalid && emailForm.get('email')?.touched
          "
          class="mt-1.5 text-sm text-red-600 dark:text-red-400"
        >
          Please enter a valid email address.
        </div>
      </div>

      <button
        type="submit"
        [disabled]="isSubmitting"
        class="btn-primary w-full py-3 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        <span *ngIf="!isSubmitting">{{ isSignUpMode ? 'Sign up' : 'Sign in' }}</span>
        <span *ngIf="isSubmitting" class="flex items-center justify-center">
          <svg
            class="animate-spin -ml-1 mr-2 h-4 w-4 inline"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Sending code...
        </span>
      </button>
    </form>

    <!-- Sign up/Sign in toggle link -->
    <p class="mt-6 text-center text-sm text-gray-600 dark:text-gray-400">
      <span *ngIf="!isSignUpMode">
        Don't have an account? 
        <button 
          type="button" 
          (click)="toggleSignUpMode()" 
          class="font-semibold text-gray-900 dark:text-white hover:underline focus:outline-none"
        >
          Sign up
        </button>
      </span>
      <span *ngIf="isSignUpMode">
        Already have an account? 
        <button 
          type="button" 
          (click)="toggleSignUpMode()" 
          class="font-semibold text-gray-900 dark:text-white hover:underline focus:outline-none"
        >
          Sign in
        </button>
      </span>
    </p>
      </div>

      <!-- Verification Code Step (shown in same right panel when code is sent) -->
    <div *ngIf="showVerificationForm" class="w-full">
      <div class="text-center mb-8">
        <div class="w-16 h-16 mx-auto mb-5 rounded-full bg-green-200 dark:bg-green-900/30 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-green-600 dark:text-green-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
          Check your email
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          We've sent a verification code to
          <span class="font-semibold text-gray-900 dark:text-white">{{ emailForm.get("email")?.value }}</span>
        </p>
      </div>

      <form [formGroup]="verificationForm" (ngSubmit)="verifyCode()">
        <div class="mb-5">
          <label
            for="code"
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
          >
            Verification code
          </label>
          <input
            type="text"
            id="code"
            formControlName="code"
            class="w-full px-4 py-3 rounded-lg border bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black/15 dark:focus:ring-white/25 focus:border-transparent transition-all duration-200 text-center tracking-[0.3em] text-lg font-medium"
            [class.border-gray-300]="!errorMessage"
            [class.dark:border-gray-600]="!errorMessage"
            [class.border-red-600]="errorMessage"
            [class.dark:border-red-700]="errorMessage"
            placeholder="000000"
            [class.is-invalid]="
              verificationForm.get('code')?.invalid &&
              verificationForm.get('code')?.touched
            "
            maxlength="6"
            autocomplete="one-time-code"
          />
          <div
            *ngIf="
              verificationForm.get('code')?.invalid &&
              verificationForm.get('code')?.touched
            "
            class="mt-1.5 text-sm text-red-600 dark:text-red-400"
          >
            Please enter a valid verification code.
          </div>
        </div>

        <button
          type="submit"
          [disabled]="isVerifyingCode"
          class="btn-primary w-full py-3 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
        >
          <span *ngIf="!isVerifyingCode">Verify code</span>
          <span *ngIf="isVerifyingCode" class="flex items-center justify-center">
            <svg
              class="animate-spin -ml-1 mr-2 h-4 w-4 inline"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Verifying...
          </span>
        </button>
      </form>

      <div class="border-t border-gray-200 dark:border-gray-700 pt-5 mt-6">
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4 text-center">
          Didn't receive the code? Check your spam folder.
        </p>

        <button
          type="button"
          (click)="resendCode()"
          [disabled]="
            isResendingCode ||
            (resendCooldownActive && showResendCooldownOnButton) ||
            isSubmitting
          "
          class="btn-secondary w-full disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
        >
          <span *ngIf="isResendingCode" class="flex items-center justify-center">
            <svg
              class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700 dark:text-gray-300 inline"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Resending...
          </span>
          <span
            *ngIf="
              !isResendingCode &&
              resendCooldownActive &&
              showResendCooldownOnButton
            "
          >
            Resend in {{ resendTimerDisplay }}
          </span>
          <span
            *ngIf="
              !isResendingCode &&
              (!resendCooldownActive || !showResendCooldownOnButton)
            "
          >
            Resend code
          </span>
        </button>
      </div>
    </div>

      <!-- Legal: visible only when registering; invisible on sign in keeps layout height -->
      <div
        *ngIf="!showVerificationForm"
        class="mt-8 text-center text-[11px] leading-relaxed text-gray-500 dark:text-gray-500"
        [class.invisible]="!isSignUpMode"
        [class.pointer-events-none]="!isSignUpMode"
        [attr.aria-hidden]="!isSignUpMode ? true : null"
      >
        <p>
          By continuing you agree to our
          <a
            routerLink="/terms"
            class="underline underline-offset-2 hover:text-gray-700 dark:hover:text-gray-300"
            (click)="closeModal()"
          >
            Terms of Service
          </a>
          ,
          <a
            routerLink="/privacy"
            class="underline underline-offset-2 hover:text-gray-700 dark:hover:text-gray-300"
            (click)="closeModal()"
          >
            Privacy Policy
          </a>
          , and
          <a
            routerLink="/cookies"
            class="underline underline-offset-2 hover:text-gray-700 dark:hover:text-gray-300"
            (click)="closeModal()"
          >
            Cookie Policy
          </a>
          .
        </p>
      </div>
      </div>
    </div>
  </div>
</app-modal>
